import React from 'react';
import Banner from "../../components/Banner";
import FloatingSignUp from "../../components/FloatingSignUp";

const LandingBanner = (props) => {
    return (
        <div style={{
            width: '100%',
        }}>
        <Banner type="landing" history={props.history} />

        </div>
    );
};

export default LandingBanner;
